import axios from 'axios';
import { serverUrl } from '../../components/Helpers/Config';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const USER_PREFERENCE = "USER_PREFERENCE";
export const USER_NAVIGATING_CONFRIM_POPUP = "USER_NAVIGATING_CONFRIM_POPUP";

export const getUserPreference = () => {
    return (dispatch, getState) => {
        return axios.get(
            serverUrl.GetUserPreferences,
        ).then(resp => {
            if (resp.status === 200) {
                dispatch({ 'type': 'USER_PREFERENCE', data: resp.data });
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
        });
    }
}

export const putUserPreference = (data) => {
    return (dispatch, getState) => {
        return axios.put(
            serverUrl.ActionUserPreference,
            data,
        ).then(resp => {
            if (resp.status === 200) {
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
        });
    }
}

export const getUserNavigationConfrimPopup = (bool) => {
    return (dispatch, getState) => {
        dispatch({ type: USER_NAVIGATING_CONFRIM_POPUP, data: bool });
    }
}